import { moneyToNumber } from "@babybjorn/utils/commercetools/money";
import type { Order } from "@commercetools/platform-sdk";
import { type EcommerceItem, getEcommerceItem } from "../use-gtm-variables";

interface PurchaseEventData {
	ecommerce: {
		purchase: {
			actionField: {
				id: string;
				affiliation: string;
				revenue: string;
				tax: string;
				shipping: string;
				coupon?: string;
			};
			products: EcommerceItem[];
		};
	};
	email: string;
	phone_number: string;
}

export const getData = (order: Order): PurchaseEventData => {
	const orderTotalGross = moneyToNumber(order.taxedPrice?.totalGross);

	const orderTotalNet = moneyToNumber(order.taxedPrice?.totalNet);

	const orderCodes =
		order.discountCodes?.map((code) => code.discountCode.obj?.code) || [];

	return {
		ecommerce: {
			purchase: {
				actionField: {
					id: order.orderNumber || "",
					affiliation: `Babybjorn ${process.env.GATSBY_STORE}`,
					revenue: orderTotalGross.toString(), // Total transaction value (incl. tax and shipping)
					tax: (orderTotalGross - orderTotalNet).toString(),
					shipping: moneyToNumber(order.shippingInfo?.price).toString(),
					coupon: orderCodes[0],
				},
				products: order.lineItems.map(getEcommerceItem),
			},
		},
		email: order.billingAddress?.email || "",
		phone_number: order.billingAddress?.phone || "",
	};
};
